import React from 'react';
import Img from 'gatsby-image';

const TeamMember = props => {
  const { sizes } = props;
  const { name, type, description, photo, left } = props.data;

  return (
    <div className="row page-margin-top-section team-member">
      <div className="column column-1-2">
        <h3>{name}</h3>
        <h5 className="box-header">{type}</h5>
        <p className="description">{description}</p>
      </div>
      <div className="column column-1-2">
        <Img sizes={sizes} imgStyle={{ objectPosition: '0 0' }} style={{ width: '100%' }} />
      </div>
    </div>
  )
};

export default TeamMember;

// return (
//     <div className="row page-margin-top-section">
//       <div className="column column-1-2">
//         <Img sizes={sizes} imgStyle={{ objectPosition: '0 0' }} style={{ width: '100%' }} />
//       </div>
//       <div className="column column-1-2 align-right">
//         <h3>{name}</h3>
//         <h5 className="box-header">{type}</h5>
//         <p className="description">{description}</p>
//       </div>
//     </div>
//   );
// };



// WEBPACK FOOTER //
// ./src/components/TeamMember.js